import { DocumentValue } from './document-value';
import { Template } from './template';
export class Document {

  transportId: number;

  choicesByKey = [];

  deleted = false;
  id: number;
  title: string;
  template: Template;
  values: DocumentValue[] = [];
  
  // Raw values beinhalten alle werte, auch deaktivierte und readonly werte
  rawValues: DocumentValue[] = [];

  constructor(doc: any) {
    this.transportId = doc.transportId;
    this.deleted = doc.deleted;
    this.id = doc.id;
    this.template = new Template(doc.template);
    if (doc.values != null) {
      for (const value of doc.values) {
        this.values.push(new DocumentValue(value));
        this.rawValues.push(new DocumentValue(value));
      }
    }

    // Selektion von Choices setzen
    for (const templateArea of this.template.areas) {
      if (templateArea.choiceAttribute != null) {
        const value = this.values.find(v => v.key === templateArea.choiceAttribute.key);
        templateArea.choiceAttribute.choiceSelected = (value != null && value.value === 'true');
      }
    }
  }

}
